module.exports = __webpack_public_path__ + "img/bg-image-desktop.a725cf1f.svg";